export default "__VITE_ASSET__c4ac9dfd__";